module.exports = __webpack_public_path__ + "static/media/README.b152fe27.md";